import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { OngoingRequestTrackerService, SessionService } from '@core';

import { GenerateRoutesResult } from '../../models/generate-routes-result.model';
import {ProblemInstanceService} from "../problem-instance/problem-instance.service";

@Injectable({ providedIn: 'root' })
export class GenerateRoutesService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);
    private readonly problemInstanceService = inject(ProblemInstanceService);
    private readonly ongoingRequestTracker = inject(OngoingRequestTrackerService);


    public generateRoutes(): Observable<GenerateRoutesResult> {
        const url = `${this.sessionService.getApiUrl()}/generate_routes_v4/${this.sessionService.requestId}`;
        const requestOptions = this.ongoingRequestTracker.createTrackingEnabledRequestOptions();

        return this.httpClient.post<GenerateRoutesResult>(url, {}, requestOptions);
    }
}
